import { createContext, useContext, useState, useCallback } from "react";

const AdminAuthContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = "admin_pw";

export function AdminAuthProvider({ children }) {
  const [password, setPassword] = useState(() => sessionStorage.getItem(STORAGE_KEY) || "");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [checking, setChecking] = useState(true);

  const adminHeaders = useCallback(() => {
    const pw = sessionStorage.getItem(STORAGE_KEY) || "";
    return { "X-Admin-Password": pw };
  }, []);

  const login = useCallback(async (pw) => {
    const res = await fetch(`${API_URL}/api/admin/verify`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password: pw }),
    });
    if (res.ok) {
      sessionStorage.setItem(STORAGE_KEY, pw);
      setPassword(pw);
      setIsAuthenticated(true);
      return true;
    }
    return false;
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem(STORAGE_KEY);
    setPassword("");
    setIsAuthenticated(false);
  }, []);

  const checkSession = useCallback(async () => {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    if (!saved) { setChecking(false); return; }
    try {
      const res = await fetch(`${API_URL}/api/admin/verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: saved }),
      });
      if (res.ok) {
        setPassword(saved);
        setIsAuthenticated(true);
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch {}
    setChecking(false);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ isAuthenticated, checking, password, login, logout, checkSession, adminHeaders }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
}
